var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsDislikeIcon = function SvgDsDislikeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.178 14.941a.67.67 0 0 1-.608.392 2.72 2.72 0 0 1-1.905-.777 2.65 2.65 0 0 1-.794-1.89v-2H2.707a2.04 2.04 0 0 1-1.54-.683A2 2 0 0 1 .69 8.365l.935-6c.074-.48.321-.915.693-1.226.37-.31.84-.477 1.324-.472h9.67c.533 0 1.046.208 1.426.582s.595.884.595 1.418v4.666a2 2 0 0 1-.595 1.418c-.38.374-.893.582-1.426.582H11.71zm1.435-6.418L8.166 13.94a1.4 1.4 0 0 1-.565-.334 1.32 1.32 0 0 1-.397-.94V10a.667.667 0 0 0-.666-.667H2.696a.7.7 0 0 1-.53-.233.66.66 0 0 1-.158-.532l.934-6a.66.66 0 0 1 .231-.406A.7.7 0 0 1 3.631 2h6.982zM11.946 2v6h1.366a.7.7 0 0 0 .49-.199.66.66 0 0 0 .198-.468V2.667a.66.66 0 0 0-.198-.468.7.7 0 0 0-.49-.199z",
    clipRule: "evenodd"
  })));
};
export default SvgDsDislikeIcon;